import 'lazysizes';
import './plugins/a11y-toggle';
import './plugins/externalLinks';
import './plugins/jumpLinks';
import './plugins/shareLinks';
import './plugins/scrolldir';
import StickyState from 'sticky-state';
import Flickity from 'flickity';
import Animate from 'animate.js';
import Cleave from 'cleave.js';

// Add "js" class to the html element
document.documentElement.className = document.documentElement.className.replace(
    'no-js',
    'js'
);

new StickyState(document.querySelectorAll('.sticky'));

const carousel = document.getElementById('carousel');
if (carousel) {
    const flickity = new Flickity(carousel, {
        cellSelector: '#carousel--slide',
        cellAlign: 'left',
        pageDots: false,
        wrapAround: true,
        lazyLoad: 1,
    });
    setTimeout(() => {
        flickity.resize();
    }, 250);
}

// Wrap footnote content in footnote--text for styling purposes
const notes = Array.from(document.querySelectorAll('.footnote'));
notes.forEach(note => {
    const noteText = note.innerHTML;
    note.innerHTML = `<span class="footnote--text">${noteText}</span>`;
});

// Animate elements as they enter the viewport
const animate = new Animate({
    delay: 200,
    offset: 0,
    scrolled: true,
    onLoad: true,
});
animate.init();

// Add formatting to date inputs
Array.from(document.querySelectorAll('input.date')).forEach(input => {
    input.placeholder = 'MM/DD/YYYY';
    new Cleave(input, {
        date: true,
        datePattern: ['m', 'd', 'Y'],
    });
});



// WEBPACK FOOTER //
// src/js/site.js